<template>
<div class="index_content">
  <Layout>
    <Sider width="208">
      <div class="right_column">
        <div class="top-tip top-left">快讯
          <div class="top">
            <img class="logo" :src="static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">
            <span>提供支持</span>
          </div>
        </div>
        <div class="keyword-input">
          <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
        </div>
        <div class="rigit_title">
          <span>筛选</span>
          <Dropdown placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
            <a href="javascript:void(0)">
              <span>{{screen_active}}</span>
              <Icon type="md-arrow-dropup" v-if="drop_val" />
              <Icon type="md-arrow-dropdown" v-else />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="rigit_content">
          <div class="screen_ul">
            <!-- <div class="screen_li" v-show="screen_active === '全部分类' || screen_active === '热门领域'">
              <div class="screen_tle" @click="screen_tle.dynview_tag_ids = !screen_tle.dynview_tag_ids">
                <span>热门领域</span>
                <Icon type="md-add" v-if="!screen_tle.dynview_tag_ids" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.dynview_tag_ids">
                <CheckboxGroup v-model="params.dynview_tag_ids" @on-change="clearGetList">
                  <Checkbox v-for="(item,index) in  news_hot_tag_map" :label="item.id" :key="index" v-show="index < 10 || showAllTag">
                    <span>{{item.name}}({{item.id | dealName(tag_count,'id','num','0')}})</span>
                  </Checkbox>
                </CheckboxGroup>
                <span class="more_sel" @click="showAllTag = !showAllTag" v-if="news_hot_tag_map && news_hot_tag_map.length > 10">
                  <template v-if="!showAllTag">查看更多</template>
                  <template v-else>收起更多</template>
                </span>
              </div>
            </div> -->
            <div class="screen_li" v-show="screen_active === '全部分类' || screen_active === '时间选择'">
              <div class="screen_tle" @click="screen_tle.time = !screen_tle.time">
                <span>时间选择</span>
                <Icon type="md-add" v-if="!screen_tle.time" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.time">
                <RadioGroup v-model="sel_time" vertical @on-change="haddleTime">
                  <Radio label="">
                    <span>不限</span>
                  </Radio>
                  <Radio v-for="(item, tindex) in time_option" :label="item" :key="tindex">
                    <span>{{item + 1}}天 <template v-if="time_count[item + 1]">({{time_count[item + 1]}})</template></span>
                  </Radio>
                  <Radio label="zdy">
                    <span>自定义</span>
                  </Radio>
                </RadioGroup>
                <div class="zdy_time" v-if="sel_time == 'zdy'">
                  <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="s_time_options" @on-change="clearGetList" :clearable="false"></DatePicker>
                  <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="e_time_options" @on-change="clearGetList" :clearable="false"></DatePicker>
                </div>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部分类' || screen_active === '地域选择'">
              <div class="screen_tle" @click="screen_tle.address = !screen_tle.address">
                <span>地域选择</span>
                <Icon type="md-add" v-if="!screen_tle.address" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.address">
                <RadioGroup v-model="params.demostic" vertical @on-change="haddleAddress">
                  <Radio label="">
                    <span>不限</span>
                  </Radio>
                  <Radio :label="0">
                    <span>国外 <template v-if="address_count.foreign">({{address_count.foreign | empty('0')}})</template></span>
                  </Radio>
                  <Radio :label="1">
                    <span>国内 <template v-if="address_count.china">({{address_count.china | empty('0')}})</template></span>
                  </Radio>
                </RadioGroup>
                <!-- <div class="sec_options" v-if="params.demostic == 1">
                                      <Checkbox v-model="city_all" class="all_option" @on-change="haddleAllCity" :disabled="city_all">
                                          <span>全部</span>
                                      </Checkbox>
                                      <CheckboxGroup v-model="params.address_id" @on-change="haddleCity">
                                          <Checkbox
                                              v-for="(item,index) in city"
                                              :label="item.id"
                                              :key="index"
                                              v-show="index < 10 || city_show"
                                          >
                                              <span>{{item.name}}</span>
                                          </Checkbox>
                                      </CheckboxGroup>
                                      <span class="more_sel" @click="city_show = !city_show">
                                          <template v-if="!city_show">查看更多</template>
                                          <template v-else>收起更多</template>
                                      </span>
                                  </div> -->
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部分类' || screen_active === '话题类型'">
              <div class="screen_tle" @click="screen_tle.type = !screen_tle.type">
                <span>话题类型</span>
                <Icon type="md-add" v-if="!screen_tle.type" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.type">
                <Checkbox v-model="type_all" class="all_option" @on-change="haddleAllType" :disabled="type_all">
                  <span>不限</span>
                </Checkbox>
                <div class="ivu-checkbox-group ivu-checkbox-default">
                  <label v-for="item,nindex in news_topic_type" :label="item.id" v-show="nindex < 10 || type_show" :key="nindex" @click="haddleType(item)" :class="{ 'ivu-checkbox-wrapper': true,
                                                    'ivu-checkbox-group-item': true,
                                                    'ivu-checkbox-default': true,
                                                    'ivu-checkbox-wrapper-checked': params.type.findIndex((a) => a == item.id) > -1}">
                    <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': params.type.findIndex((a) => a == item.id) > -1}">
                      <span class="ivu-checkbox-inner"></span>
                    </span>
                    <span>{{item.name}} <template v-if="topic_type_count[item.id]">({{topic_type_count[item.id] | empty('0')}})</template></span>
                  </label>
                </div>
                <span class="more_sel" @click="type_show = !type_show" v-if="news_topic_type && news_topic_type.length > 10">
                  <template v-if="!type_show">查看更多</template>
                  <template v-else>收起更多</template>
                </span>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部分类' || screen_active === '关注列表'">
              <div class="screen_tle" @click="screen_tle.attention = !screen_tle.attention">
                <span>关注列表</span>
                <Icon type="md-add" v-if="!screen_tle.attention" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.attention">
                <ul class="scr_attention">
                  <li>
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention.tag || !user_key" @click="haddleAttentionSel('tag')" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel('tag')" />
                      <span @click="haddleAttentionSel('tag')">关注领域</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention.tag" v-if="user_key">
                      <CheckboxGroup v-model="params.dynview_tag_ids" @on-change="clearGetList" v-if="subscribe_tag && subscribe_tag.length > 0">
                        <Checkbox v-for="(item,index) in subscribe_tag" :label="item" :key="index" v-show="index < 10 || atte_show.tag">
                          <span>{{item | dealName(meta.entity_ntag)}} ({{item | dealName(topic_tag_count,'id','num','0')}})</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <p class="none_tip" v-if="subscribe_tag && subscribe_tag.length == 0">暂无关注领域，<a @click="haddleSetAtten1(1,'field')">去关注</a></p>
                      <span class="more_sel" @click="haddleAtteShow('tag')" v-if="subscribe_tag && subscribe_tag.length > 10">
                        <template v-if="!atte_show.tag">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention.comp || !user_key" @click="haddleAttentionSel('comp')" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel('comp')" />
                      <span @click="haddleAttentionSel('comp')">关注公司</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention.comp" v-if="user_key">
                      <CheckboxGroup v-model="params.entity_uids" @on-change="haddleEntity" v-if="topic_comp_count && topic_comp_count.length > 0">
                        <Checkbox v-for="(item,index) in topic_comp_count" :label="item.uid" :key="index" v-show="index < 10 || atte_show.comp">
                          <span>{{item.short_name}} ({{item.num}})</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <p class="none_tip" v-else>暂无关注公司，<a @click="haddleSetAtten1(1,'comp')">去关注</a></p>
                      <span class="more_sel" @click="haddleAtteShow('comp')" v-if="topic_comp_count && topic_comp_count.length > 10">
                        <template v-if="!atte_show.comp">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention.org || !user_key" @click="haddleAttentionSel('org')" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel('org')" />
                      <span @click="haddleAttentionSel('org')">关注机构</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention.org" v-if="user_key">
                      <CheckboxGroup v-model="params.entity_uids" @on-change="haddleEntity" v-if="topic_org_count.length">
                        <Checkbox v-for="(item,index) in topic_org_count" :label="item.uid" :key="index" v-show="index < 10 || atte_show.org">
                          <span>{{item.short_name}} ({{item.num}})</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <p class="none_tip" v-else>暂无关注机构，<a @click="haddleSetAtten1(1,'org')">去关注</a></p>
                      <span class="more_sel" @click="haddleAtteShow('org')" v-if="topic_org_count && topic_org_count.length > 10">
                        <template v-if="!atte_show.org">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </li>
                  <li v-for="(item,index) in attention.group" :key="'g'+index" v-if="attention.group.length">
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention['g'+item.id] || !user_key" @click="haddleAttentionSel('g'+item.id)" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel('g'+item.id)" />
                      <span @click="haddleAttentionSel('g'+item.id)">{{item.name}}</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention['g'+item.id]" v-if="user_key">
                      <CheckboxGroup v-model="params.entity_uids" @on-change="haddleEntity" v-if="group_entitys(item.id).length">
                        <Checkbox v-for="(item2,index2) in group_entitys(item.id)" :label="item2.uid" :key="index2" v-show="index2 < 10 || atte_show['g'+item.id]">
                          <span>{{item2.short_name}} ({{item2.num}})</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <p class="none_tip" v-else>未添加任何关注，<a @click="haddleSetAtten2(item.id)">去关注</a></p>
                      <span class="more_sel" @click="haddleAtteShow('g'+item.id)" v-if="group_entitys(item.id) && group_entitys(item.id).length > 10">
                        <template v-if="!atte_show['g'+item.id]">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </li>
                  <li v-for="(item,index) in zt_list" :key="'zt'+index">
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention[item.id] || !user_key" @click="haddleAttentionSel(item.id)" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel(item.id)" />
                      <span @click="haddleAttentionSel(item.id)">{{item.name}}</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention[item.id]" v-if="user_key">
                      <CheckboxGroup v-model="params.entity_uids" @on-change="haddleEntity" v-if="item.entitys.length">
                        <Checkbox v-for="(item2,index2) in item.entitys" :label="findZtEntityUid(item2.id)" :key="index2" v-show="(index2 < 10 || atte_show[item.id]) && (item2.type == '0' || item2.type == '1')">
                          <span>{{findZtEntity(item2.id)}}</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <!-- <span class="more_sel" @click="haddleAtteShow(item.id)" v-if="ids2entity(item.comp.concat(item.org)) && ids2entity(item.comp.concat(item.org)).length > 10">
                        <template v-if="!atte_show[item.id]">查看更多</template>
                        <template v-else>收起更多</template>
                      </span> -->
                    </div>
                  </li>
                  <li v-for="(item,index) in yz_group" :key="'yz'+index">
                    <div class="scr_att_tle">
                      <Icon type="md-arrow-dropright" v-if="!screen_attention[item.id] || !user_key" @click="haddleAttentionSel(item.id)" />
                      <Icon type="md-arrow-dropdown" v-else @click="haddleAttentionSel(item.id)" />
                      <span @click="haddleAttentionSel(item.id)">{{item.name}}</span>
                    </div>
                    <div class="scr_att_cnt" v-show="screen_attention[item.id]" v-if="user_key">
                      <CheckboxGroup v-model="params.entity_uids" @on-change="haddleEntity" v-if="ids2entity(item.comp.concat(item.org)).length">
                        <Checkbox v-for="(item2,index2) in ids2entity(item.comp.concat(item.org))" :label="item2.uid" :key="index2" v-show="index2 < 10 || atte_show[item.id]">
                          <span>{{item2.short_name}} ({{item2.num}})</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <span class="more_sel" @click="haddleAtteShow(item.id)" v-if="ids2entity(item.comp.concat(item.org)) && ids2entity(item.comp.concat(item.org)).length > 10">
                        <template v-if="!atte_show[item.id]">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </li>
                  <!-- <li>
                    <a @click="haddleAddAtten"><Icon type="md-add" />添加分组</a>
                  </li> -->
                </ul>
                <a @click="haddleSetAtten1()" class="add_atten">+ 添加关注</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sider>
    <Content>
      <p class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span></p>
      <div class="sel_opt" v-if="allOption && allOption.length > 0">
        <div class="sel_tle">已选条件</div>
        <div class="sel_cnt">
          <span v-for="(item,index) in allOption" :key="index" @click="haddleCloseOpt(item)">{{item.name}}
            <Icon type="md-close" />
          </span>
        </div>
        <div class="sel_clear">
          <span @click="haddleClearOpt"><i class="iconfont">&#xe63e;</i>清空筛选</span>
        </div>
      </div>
      <div class="info">
        <p><i class="iconfont">&#xe649;</i>{{nowTime}}</p>
        <div class="info_right">
          <Checkbox v-model="tj_chk" @on-change="haddleTj"><span>只看推荐的</span></Checkbox>
          <div class="swi">桌面通知<i-switch v-model="tip_switch" @on-change="haddleTipSwitch" size="small"></i-switch>
          </div>
        </div>
      </div>
      <div :class="{'advList': true, 'latest': latest_num > 0}" v-if="adv_img">
        <a :href="adv_img.link" target="_blank" @click="handleClickAdv(adv_img.uid,adv_img.id)">
          <img :src="img_req_url + adv_img.img_path" />
        </a>
      </div>
      <div class="new_tip" v-if="latest_num > 0">
        <p @click="haddleLatestRes">有{{latest_num}}条新消息，点击查看</p>
        <Icon type="md-close" @click="haddleLatestTip" />
      </div>
      <ul class="news_list noselect" oncontextmenu="return false" onselectstart="return false">
        <li v-for="(item1, index1) in newsList" :key="index1">
          <ul>
            <div class="d-time" v-if="isToday(item1.time)">
              <span v-if="isToYear(item1.time)">
                {{Md(item1.time)}}
              </span>
              <span v-else>
                {{Ymd(item1.time)}}
              </span>
            </div>
            <li :class="{item:true , already: topic_read_uids.findIndex((a) => item2.uid == a) > -1}" v-for="(item2, index2) in item1.arr" :key="index2">
              <div class="time">
                {{Ms(item2.create_time)}}
              </div>
              <div class="line">
                <img :src="static_img_url + 'pic/new_ico.png'" v-if="item2.weight <= 3 && topic_read_uids.findIndex((a) => item2.uid == a) == -1" />
                <img :src="static_img_url + (!theme_switch ? 'pic/new_ico_b.png' : 'pic/new_ico_l.png')" v-if="item2.weight <= 3 && topic_read_uids.findIndex((a) => item2.uid == a) > -1" />
                <img :src="static_img_url + 'pic/new_ico2.png'" v-if="item2.weight > 3 && topic_read_uids.findIndex((a) => item2.uid == a) == -1" class="recommend" />
                <img :src="static_img_url + (!theme_switch ? 'pic/new_ico2_b.png' : 'pic/new_ico2_l.png')" v-if="item2.weight > 3 && topic_read_uids.findIndex((a) => item2.uid == a) > -1" class="recommend" />
              </div>
              <div class="content">
                <div>
                  <a @click="goDetail(item2)" class="a1">
                    <span class="tag" v-for="(item3, index3) in item2.type_arr" :key="index3">{{item3 | deal('news_topic_type')}}</span>
                    <i class="line_i" v-if="item2.type_arr && item2.type_arr.length > 0"></i>{{item2.title}}
                  </a>
                  <a @click="goDetail(item2)" class="a2">
                    {{item2.content_unsigned}}
                    <template v-if="item2.src_name">
                      （{{item2.src_name}}<template v-if="item2.content_count > 1"> 等{{item2.content_count}}家媒体报道</template>）
                    </template>
                  </a>
                </div>
                <div class="div-img" v-if="item2 && item2.length!=0">
                  <img :preview="item2.id" v-for="(item4, index4) in item2.file_arr" :key="index4" :src="img_req_url + item4.path" onclick="_czc.push(['_trackEvent', '快讯列表页', '打开图片点击']))">
                </div>
                <div class="last-item-row">
                  <div class="item-row">
                    <div class="t-address" v-if="item2.address_id"><span>{{item2.address_id | addressDeal}}</span></div>
                    <!-- <div class="tag-list" v-if="getFirstEntity('0', item2.entity) || getFirstEntity('1', item2.entity)">
                      <i class="iconfont">&#xe660;</i>
                      <span v-if="getFirstEntity('0', item2.entity)">
                        <a href="javascript:void(0)" @click="goEntity('0',getFirstEntity('0', item2.entity).uid)">{{getFirstEntity('0', item2.entity).short_name}}</a>
                      </span>
                      <span v-if="getFirstEntity('1', item2.entity)">
                        <a href="javascript:void(0)" @click="goEntity('1',getFirstEntity('1', item2.entity).uid)">{{getFirstEntity('1', item2.entity).short_name}}</a>
                      </span>
                    </div> -->
                    <div class="tag-list" v-if="item2.entity.length != 0">
                      <i class="iconfont">&#xe660;</i>
                      <span v-for="item3,index3 in item2.entity" :key="item3.uid">
                        <a href="javascript:void(0)" @click="goEntity(item3.type, item3.uid)">{{item3.short_name}}</a>
                      </span>
                    </div>
                  </div>
                  <div class="spa">
                    <!-- <span>分享至</span> -->
                    <i class="iconfont s active" title="取消收藏" v-if="item2.is_collect" @click="cancelCollect('0', item2.id, delCollectCb, {index1: index1,index2: index2})">&#xe66f;</i>
                    <i class="iconfont s" title="收藏" v-if="!item2.is_collect" @click="addCollect('0', item2.id, addCollectCb, {index1: index1,index2: index2})">&#xe66f;</i>
                    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item2.uid)" @on-popper-hide="haddleShareHide">
                      <i class="iconfont w">&#xe641;</i>
                      <div slot="content" class="share_cnt clear">
                        <div class="share_img"></div>
                        <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                      </div>
                    </Poptip>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>

      <Nothing v-if="!g_index && len == 0">
        <p>亲，您还未添加关注的主题，<a @click="haddleSetAtten1(1,'comp')">去关注</a></p>
      </Nothing>
      <div class="more" v-else>
        <button @click="haddleMoreList" v-if="len == 10 && !listLoading" onclick="_czc.push(['_trackEvent', '快讯列表页', '底部查看更多点击'])">加载更多</button>
        <p class="no_more" v-if="len < 10 && !listLoading">没有更多内容了</p>
        <Spin fix v-if="listLoading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <CreateAttention :createAttentionModal="create_attention"></CreateAttention>
      <OrgModal ref="org_modal" :imgurl="org_modal_img">
        <p class="p1" slot>{{org_modal_p}}</p>
      </OrgModal>
    </Content>
  </Layout>
</div>
</template>

<script>
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  topicList,
  topicLatest,
  topicCount,
  pushTopic,
  advList,
  tagTopicNum,
  getMapTag,
  addPuv
} from '../../service'
import {
  attention_mixins
} from 'js/attention_mixins'
import {
  get_meta
} from 'js/get_meta'
import {
  collect_mixin
} from 'js/collect_mixin'
import {
  left_scroll
} from 'js/left_scroll'
import {
  userInfo
} from 'js/userInfo'
import { getAddPuv } from 'js/addPuv.js'
import CreateAttention from '@/components/CreateAttention.vue'
import OrgModal from '@/components/OrgModal.vue'
import Nothing from '@/components/Nothing.vue'
import moment from 'moment'
import filter from 'js/filter'
import Push from 'push.js'

export default {
  inject: ['haddleApplyTry2', 'login'],
  name: 'NewsList',
  mixins: [attention_mixins, userInfo, collect_mixin, left_scroll, getAddPuv, get_meta],
  components: {
    CreateAttention,
    Nothing,
    OrgModal
  },
  data() {
    const _that = this
    return {
      time_option: [2, 4, 6, 14, 29],
      listLoading: true,
      params: {
        days: '',
        type: [],
        page: 1,
        s_time: '',
        e_time: '',
        demostic: '',
        address_id: [],
        is_tj: '',
        group_id: [],
        keyword: '',
        dynview_tag_ids: [],
        entity_uids: [],
        entity_ids: [],
        latest_time: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      search_ipt: '',
      search_phd: '',
      news_hot_tag_map: [],
      showAllTag: false,
      type_show: false,
      type_all: true,
      sel_time: '',
      s_time_options: {
        disabledDate(date) {
          if (_that.params.e_time) {
            return moment(_that.params.e_time).isBefore(date)
          } else {
            return false
          }
        }
      },
      e_time_options: {
        disabledDate(date) {
          if (_that.params.s_time) {
            return moment(_that.params.s_time).isAfter(date)
          } else {
            return false
          }
        }
      },
      city_show: false,
      city_all: true,

      screen_tle: {
        dynview_tag_ids: false,
        time: false,
        address: false,
        type: false,
        attention: true
      },
      screen_active: '全部分类',
      // screen_dropdown: ['全部分类', '热门领域', '时间选择', '地域选择', '话题类型', '关注列表'],
      screen_dropdown: ['全部分类', '时间选择', '地域选择', '话题类型', '关注列表'],
      sel_address: '',
      screen_attention: {},
      atte_show: {},
      attention_tag_all: false,
      nowTime: moment().format("YYYY年MM月DD日， dddd"),
      latest_params: {
        time: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      latest_num: 0,
      newsList: [],
      len: 0,
      tj_chk: false,
      filter: filter,
      create_attention: {
        model: false,
        id: '',
        name: ''
      },
      // loginModal: false

      pushtopic_params: {
        type: [],
        days: '',
        is_tj: '',
        group_id: '',
        entity_uids: [],
        time: moment().format('YYYY-MM-DD HH:mm:ss'),
        limit: '1'
      },

      address_count: '',
      time_count: {},
      topic_type_count: {},
      tag_count: [],
      tip_switch: true,
      default_group: {},
      adv_img: '',
      timer: null,
      // page_modal: true, // 机构版宣传框
      drop_val: false,
      total: 0
    }
  },
  computed: {
    news_topic_type() {
      return this.$store.state.news_topic_type
    },
    theme_switch() {
      return this.$store.state.theme_switch
    },
    static_img_url() {
      return this.$store.state.static_img_url
    },
    allOption() {
      let optionKeyWord = [],
        s_type = [],
        s_days = [],
        s_s_time = [],
        s_e_time = [],
        s_address_id = [],
        s_demostic = [],
        s_atten = [],
        s_dynview_tag_ids = [],
        s_entity_uids = [],
        s_group = [],
        s_default = []
      this.params.type.map((a) => {
        s_type.push({
          type: 'type',
          name: filter.deal(a, 'news_topic_type'),
          id: a
        })
      })
      if (this.params.days != '' && this.sel_time != 'zdy') {
        s_days = {
          type: 'days',
          name: this.params.days + 1 + '天',
          id: this.params.days
        }
      }
      if (this.params.s_time != '') {
        s_s_time = {
          type: 's_time',
          name: '开始时间：' + moment(this.params.s_time).format('YYYY-MM-DD'),
          id: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        s_e_time = {
          type: 'e_time',
          name: '结束时间：' + moment(this.params.e_time).format('YYYY-MM-DD'),
          id: this.params.e_time
        }
      }
      if (this.params.demostic !== '') {
        s_demostic = {
          type: 'demostic',
          name: this.params.demostic == 0 ? '国外' : '国内',
          id: this.params.demostic
        }
      }
      this.params.address_id.map((a) => {
        s_address_id.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          id: a
        })
      })

      this.params.dynview_tag_ids.map((a) => {
        s_dynview_tag_ids.push({
          type: 'dynview_tag_ids',
          name: filter.dealName(a, this.meta.entity_ntag),
          id: a
        })
      })

      this.params.entity_uids.map((a) => {
        let index = this.topic_entity_count.findIndex((b) => a === b.uid)
        if (index > -1) {
          s_entity_uids.push({
            type: 'entity_uids',
            name: this.topic_entity_count[index].short_name,
            id: this.topic_entity_count[index].uid
          })
        }
      })

      this.params.group_id.map((a) => {
        let index = this.attention.group.findIndex((b) => a === b.id)
        if (index > -1) {
          s_group.push({
            type: 'group_id',
            name: this.attention.group[index].name,
            id: this.attention.group[index].id
          })
        }
      })
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      for (var prop in this.default_group) {
        if (this.default_group[prop]) {
          let item = this.yz_group.find((a) => a.id == prop)
          s_default.push({
            type: 'default_group',
            name: item.name,
            id: item.id
          })
        }
      }

      return [].concat(optionKeyWord, s_type, s_days, s_s_time, s_e_time, s_demostic, s_address_id, s_dynview_tag_ids, s_entity_uids, s_group, s_default)
    },
    create_g_id() {
      return this.create_attention.id
    },
    g_index() {
      let index
      if (this.attention.g_relation && this.params.group_id != '') {
        index = this.attention.g_relation.findIndex((item) => {
          return this.params.group_id == item.group_id
        })
      } else {
        index = 1
      }
      return index > -1
    },
    img_req_url() {
      return this.$store.state.img_req_url
    },
    topic_read_uids() {
      return this.$store.state.topic_read_uids
    },
    pushTopic_uids() {
      return this.$store.state.pushTopic_uids
    },
    city() {
      let address = []
      this.$store.state.address.map((a) => {
        if (a.pid == '2287') {
          address.push(a)
        }
      })
      return address
    },
    default_key() {
      let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '16'),
          key = ''
      if (index > -1) {
        key = this.$store.state.datahotsearchkey[index].name
      }
      return key
    },
    ids2entity() {
      return function(ids) {
        let arr = []
        if(this.topic_entity_count.length) {
          arr = this.topic_entity_count.filter(item => {
            let index = ids.findIndex(a => a == item.id)
            return index > -1
          })
        }
        return arr
      }
    },
    group_entitys() {
      return function(g_id) {
        let arr = this.attention.g_relation.filter(item => item.group_id == g_id)
        let arr1 = this.attention.subscribe.filter(item => {
          let index = arr.findIndex(a => a.subscribe_id == item.id)
          return index > -1
        })
        let arr2 = []
        if(this.topic_entity_count.length) {
          arr2 = this.topic_entity_count.filter(item => {
            let index = arr1.findIndex(a => a.sub_type_id == item.id)
            return index > -1
          })
        }
        return arr2
      }
    }
  },
  methods: {
    async getList() {
      this.listLoading = true
      let get_params = ''
      if (this.user_key) {
        get_params = Object.assign(this.params, {
          user_key: this.user_key
        })
      } else {
        get_params = this.params
      }
      let res = await topicList(get_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.len = res.res.length
        for (let i of res.res) {
          let index = this.newsList.findIndex((j) => j.time == i.create_time.split(' ')[0])
          if (index != -1) {
            this.newsList[index].arr.push(i)
          } else {
            this.newsList.push({
              time: i.create_time.split(' ')[0],
              arr: [i]
            })
          }
        }
        if (this.params.page == 1) this.$set(this.$data, 'total', res.count)
        this.listLoading = false
        this.$nextTick(() => this.listenerScroll('right_column'))
        this.$previewRefresh()
      } else {
        this.$Message.error(res.message)
      }
    },
    async haddleLatest() {
      let res = await topicLatest(this.latest_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // console.log(res)
        this.$set(this.$data, 'latest_num', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    goDetail(item) {
      let item_type = ''
      item.type_arr.map((a) => {
        item_type = item_type + filter.deal(a, 'news_topic_type') + ' '
      })
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯摘要点击（' + item_type + '）'])
      if (this.topic_read_uids.indexOf(item.uid) == -1) {
        this.topic_read_uids.push(item.uid)
        this.$store.commit('updateReadList', this.topic_read_uids)
        localStorage.topic_read_uids = JSON.stringify(this.topic_read_uids)
      }

      const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
      window.open(href, '_blank')
    },
    haddleScreenDropdown(name) {
      this.screen_active = name
      // console.log(name)
    },
    haddleTime(val) {
      if (!this.listLoading) {
        _czc.push(['_trackEvent', '动脉橙首页快讯', '时间筛选点击(' + val + ')'])

        if (val == '' || val == 'zdy') {
          this.params.days = ''
          this.params.s_time = ''
          this.params.e_time = ''
        } else {
          this.params.days = val
          this.params.s_time = ''
          this.params.e_time = ''
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleAddress(val) {
      if (!this.listLoading) {
        let address_name
        if (val !== '') {
          address_name = val ? '国内' : '国外'
        } else {
          address_name = '不限'
        }
        _czc.push(['_trackEvent', '动脉橙首页快讯', '地域筛选点击(' + address_name + ')'])
        this.params.address_id = []
        this.city_show = false
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleAllCity() {
      if (!this.listLoading) {
        if (this.city_all) {
          this.params.address_id = []
          this.clearGetList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleCity(arr) {
      if (!this.listLoading) {
        if (arr.length > 0) {
          this.city_all = false
        } else {
          this.city_all = true
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleAllType() {
      if (!this.listLoading) {
        if (this.type_all) {
          this.params.type = []
          this.clearGetList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleType(item) {
      if (!this.listLoading) {
        _czc.push(['_trackEvent', '动脉橙首页快讯', '话题类型点击(' + item.name + ')'])

        let index = this.params.type.findIndex((a) => a == item.id)
        if (index > -1) {
          this.params.type.splice(index, 1)
        } else {
          this.params.type.push(item.id)
        }

        if (this.params.type.length > 0) {
          this.type_all = false
        } else {
          this.type_all = true
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleEntity() {
      if (!this.listLoading) {
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleGroup() {
      if (!this.listLoading) {
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleTj() {
      if (!this.listLoading) {
        if (this.tj_chk) {
          this.params.is_tj = '1'
          _czc.push(['_trackEvent', '动脉橙首页快讯', '只看重要的勾选'])
        } else {
          this.params.is_tj = ''
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleCloseOpt(obj) {
      if (!this.listLoading) {
        switch (obj.type) {
          case 'days':
            this.params.days = ''
            this.sel_time = ''
            break;
          case 's_time':
            this.params.s_time = ''
            break;
          case 'e_time':
            this.params.e_time = ''
            break;
          case 'demostic':
            this.params.demostic = ''
            this.params.address_id = []
            break;
          case 'default_group':
            this.default_group[obj.id] = false
            this.haddleChangeDefaultIds()
            break;
          case 'keyword':
            this.params.keyword = ''
            this.search_ipt = ''
            break;
          default:
            this.params[obj.type].remove(obj.id)
        }
        if (this.params.address_id.length == 0) {
          this.city_all = true
        }
        if (this.params.type.length == 0) {
          this.type_all = true
        }

        this.clearGetList()

      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleClearOpt() {
      if (!this.listLoading) {
        this.params = {
          dynview_tag_ids: [],
          days: '',
          type: [],
          page: 1,
          s_time: '',
          e_time: '',
          demostic: '',
          keyword: '',
          address_id: [],
          is_tj: '',
          group_id: [],
          entity_uids: [],
          entity_ids: [],
        }
        this.city_all = true
        this.type_all = true
        this.sel_time = ''
        this.default_group = {}

        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    haddleMoreList() {
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯加载更多点击'])
      if (this.user) {
        if (!this.isVIP) {
          if(this.params.page == 2) { // 非会员2页
            this.$refs['org_modal'].goShow()
          } else {
            this.params.page++
            this.getList()
          }
        } else {
          if(this.params.page == 10) { // 会员10页
            this.$refs['org_modal'].goShow()
          } else {
            this.params.page++
            this.getList()
          }
        }
      } else {
        if(this.params.page < 2) {
          if(this.len== 10) {
            this.params.page++
            this.getList()
          }
        } else {
          this.login()
        }
      }
    },
    haddleShare(uid) {
      let share_link = this.$store.state.index2_path+ '/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯列表页分享入口'])
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    clearList() {
      this.newsList = []
      this.params.page = 1
    },
    clearGetList() {
      this.clearList()
      this.getList()
    },
    haddleLatestTip() {
      this.latest_num = 0
      this.latest_params.time = moment().format('YYYY-MM-DD HH:mm:ss')
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯新消息关闭按钮点击'])
    },
    haddleLatestRes() {
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯新消息点击'])
      this.params = {
        days: '',
        type: [],
        page: 1,
        s_time: '',
        e_time: '',
        demostic: '',
        address_id: [],
        is_tj: '',
        group_id: [],
        dynview_tag_ids: [],
        entity_uids: [],
        entity_ids: [],
        latest_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        keyword: ''
      }
      this.latest_params.time = moment().format('YYYY-MM-DD HH:mm:ss')
      this.latest_num = 0
      this.clearGetList()
    },
    haddleAddAtten() {
      _czc.push(['_trackEvent', '动脉橙首页快讯', '添加关注首页入口点击'])
      if (this.user_key) {
        this.create_attention.model = !this.create_attention.model
      } else {
        this.login()
      }
    },
    isToday(time) { // 是否是今天
      if (time.split(' ')[0] == moment().format('YYYY-MM-DD')) {
        return false
      } else {
        return true
      }
    },
    isToYear(time) { // 是否是今年
      if (time.split(' ')[0].split('-')[0] == moment().format('YYYY')) {
        return true
      } else {
        return false
      }
    },
    Md(time) { // 格式化月份和日期
      return moment(time).format('MM月DD日')
    },
    Ymd(time) { // 格式化年月日
      return moment(time).format('YYYY年MM月DD日')
    },
    Ms(time) { // 格式化月份和日期
      return moment(time).format('HH:mm')
    },
    // getFirstEntity(type, entity) { // 查找第一个实体
    //   let temp = false
    //   for (let i of entity) {
    //     if (i.type == type) {
    //       temp = i
    //       break
    //     }
    //   }
    //   return temp
    // },
    haddleTipSwitch() {
      let s = this.tip_switch ? '开' : '关'
      _czc.push(['_trackEvent', '动脉橙首页快讯', '桌面通知按钮点击(' + s + ')'])
      document.cookie = "tip_switch=" + this.tip_switch;
      if (this.tip_switch) Push.Permission.request()
    },
    async pushTopic() {
      // console.log(this.pushTopic_uids)
      this.pushtopic_params.user_key = this.user_key
      if (this.tip_switch) {
        let res = await pushTopic(this.pushtopic_params, (error) => {
          this.$Message.error('请求错误！')
        })
        if (res.status == 'success') {
          let len = res.res.length
          if (len > 0) {
            let s_link = this.$store.state.index2_path + '/newsDetail/' + res.res[0].uid
            if (this.pushTopic_uids.indexOf(res.res[0].uid) == -1) {
              Push.create("动脉网快讯", {
                body: '[' + len + '新消息]' + "【" + res.res[0].title + "】 " + res.res[0].content,
                icon: 'https://vcbeat.top/Public/images/logo_s.png',
                timeout: 10000,
                onClick: function() {
                  _czc.push(['_trackEvent', '桌面通知', '快讯推送点击量'])
                  window.open(s_link);
                  window.focus();
                  this.close();
                }
              })
              this.pushTopic_uids.push(res.res[0].uid)
              this.$store.commit('updatePushTopic', this.pushTopic_uids)
              localStorage.pushTopic_uids = JSON.stringify(this.pushTopic_uids)
              // console.log(this.pushTopic_uids)
            }
          }
        } else {
          this.$Message.error(res.message)
        }
      }
      this.pushtopic_params.time = moment().format('YYYY-MM-DD HH:mm:ss')
    },
    async getTopicCount1() {
      let res1 = await topicCount({
        user_key: this.user_key,
        count_type: 'address'
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res1.status == 'success') {
        this.address_count = res1.res
        this.$forceUpdate()
      } else {
        this.$Message.error(res1.msg)
      }
    },
    async getTopicCount2() {
      let res2 = await topicCount({
        user_key: this.user_key,
        count_type: 'time'
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res2.status == 'success') {
        this.time_count = {
          3: res2.res[0].three_day,
          5: res2.res[0].five_day,
          7: res2.res[0].seven_day,
          15: res2.res[0].half_month,
          30: res2.res[0].one_month,
        }
        this.$forceUpdate()
      } else {
        this.$Message.error(res2.msg)
      }
    },
    async getTopicCount3() {
      let res3 = await topicCount({
        user_key: this.user_key,
        count_type: 'topic_type'
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res3.status == 'success') {
        res3.res.map((a) => {
          this.topic_type_count[a.type_id] = a.num
        })
        this.$forceUpdate()
      } else {
        this.$Message.error(res3.msg)
      }
    },
    haddleAttentionSel(type) {
      if (this.user_key) {
        this.screen_attention[type] = !this.screen_attention[type]
        this.$forceUpdate()
      } else {
        this.login()
      }
    },
    haddleAtteShow(type) {
      if (this.user_key) {
        this.atte_show[type] = !this.atte_show[type]
        this.$forceUpdate()
      } else {
        this.login()
      }
    },
    haddleChangeDefaultIds() {
      this.params.entity_ids = []
      for (var prop in this.default_group) {
        if (this.default_group[prop]) {
          let item = this.yz_group.find((a) => a.id == prop)
          item.comp.map((a) => {
            this.params.entity_ids.push(a)
          })
          item.org.map((a) => {
            this.params.entity_ids.push(a)
          })
        }
      }
      // console.log(this.params.entity_ids)
    },
    haddleDefaultGroup() {
      this.haddleChangeDefaultIds()
      this.clearGetList()
    },
    async getAdvList() {
      let res = await advList({
        adv_pos_id: [22]
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (res.res && res.res.length > 0) {
          this.$set(this.$data, 'adv_img', res.res[0])
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.pushTopic()
          this.haddleLatest()
        }, 120000)
      }
    },
    /**
     * 产业领域数量计算-公司
     */
    async getTagNum() {
      this.news_hot_tag_map = this.meta.recommend_tag_map.filter(item => item.pid != null || item.gpid != null)
      let t_arr = []
      this.news_hot_tag_map.map((a) => {
        t_arr.push(a.id)
      })
      if (t_arr.length == 0) {
        return
      }
      let res = await tagTopicNum({
        tag_arr: t_arr
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'tag_count', res.res)
      } else {
        this.$Message.error(res.message)
      }
      this.get_collection = this.meta.getcollection
      this.refreshZtList()
    },
    async getMapTag(cb) {
      let res = await getMapTag({
        "map_id": [8]
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'news_hot_tag_map', res.res)
        if (cb) cb()
      } else {
        this.$Message.error(res.message)
      }
    },
    handleDropdown(val) {
      this.drop_val = val
    },
    addCollectCb(obj) {
      this.newsList[obj['index1']].arr[obj['index2']].is_collect = 1
    },
    delCollectCb(obj) {
      this.newsList[obj['index1']].arr[obj['index2']].is_collect = 0
    },
    goEntity(type, uid) {
      if (this.user_key) {
        if (type == '0') {
          this.$router.push({
            name: 'CompanyDetail',
            params: {
              uid: uid
            }
          })
        } else {
          this.$router.push({
            name: 'OrgDetail',
            params: {
              uid: uid
            }
          })
        }
      } else {
        this.login()
      }
    },
    async handleClickAdv(uid, id) {
      _czc.push(['_trackEvent', '快讯列表页', '专题广告位点击'])
      let puv_params = {
        user_key: this.user_key,
        url: this.$store.state.req_url+'/advClick?uid=' + uid,
        row_id: id
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    handleSearch(val) {
      if (val) {
        this.params.keyword = val
        this.search_phd = val.length > 10 ? val.substr(0, 9).concat('...') : val
        let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '16')
        if (index > -1) {
          this.$store.state.datahotsearchkey[index].name = val
        }
        this.$store.commit('updateDatahotsearchkey', this.$store.state.datahotsearchkey)
      } else {
        this.search_ipt = this.default_key
        this.params.keyword = this.default_key
      }
      this.clearGetList()
    },
    debounce(fn, wait){ // 滚动条防抖
      let timeout = null
      return () => {        
          if(timeout !== null) {
            clearTimeout(timeout)
          }
          timeout = setTimeout(fn, wait)  
      }
    }
  },
  created() {
    this.search_phd = this.default_key ? (this.default_key.length > 10 ? this.default_key.substr(0, 9).concat('...') : this.default_key) : '请输入关键字'
    if ('quit' in this.$route.query) {
      this.$store.commit('updateTiaojian', '')
    }
    if (this.$store.state.list_tiaojian) {
      this.params = {
        ...this.$store.state.list_tiaojian
      }
      if (this.params.type.length > 0) {
        this.type_all = false
      }
      this.params.page = 1
    }
    // this.getMeta(['entity_ntag', 'recommend_tag_map', 'getcollection'], this.getTagNum)
    this.getMeta(['entity_ntag', 'getcollection'])
    // this.getMapTag(this.getTagNum)
    this.getList()
    this.getTopicCount1()
    this.getTopicCount2()
    this.getTopicCount3()
    this.getAdvList()

    if ('login_lose' in this.$route.query) {
      console.log('登录状态已失效')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop > (scrollHeight - windowHeight - 100) && !this.listLoading && scrollTop > 0) {
          if (this.params.page < 5) {
            if(this.params.page == 2) {
              if (this.user) {
                if (!this.isVIP) {
                  this.$refs['org_modal'].goShow()
                } else {
                  this.haddleMoreList()
                }
              } else {
                this.login()
              }
            } else {
              this.haddleMoreList()
            }
          }
        }
        this.listenerScroll('right_column')
      }, 500)

      window.onresize = () => {
        this.listenerScroll('right_column')
      }
    })

    if (document.cookie.indexOf('tip_switch=false') > -1) {
      this.tip_switch = false
    } else {
      Push.Permission.request()
      this.tip_switch = true
    }
    this.timer = null
    this.setTimer()

    let url = window.location.href
    this.getAddPuv(url)
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    window.onresize = ''
    window.onscroll = ''
    clearInterval(this.timer)
    this.timer = null
    this.params.group_id = []
    // this.params.dynview_tag_ids = []
    this.params.entity_ids = []
    this.params.entity_uids = []
    this.$store.commit('updateTiaojian', this.params)
  },
  watch: {
    create_g_id(val) {
      if (val) {
        // this.params.group_id = [val]
        this.haddleSetAtten2(val)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/rightColumn.stylus'
.noselect
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select none
.index_content
  padding: 20px 0
  .top-left
    display flex
    align-items center
    justify-content space-between
    .top
      display flex
      justify-content center
      align-items center
      span
        font-size 12px
        color #999
        margin-left 6px
      .logo
        height 16px
        cursor pointer
  .top-tip
    font-size: 18px
    commonColor(#E9E9EB, #333333)
    font-weight: 600
    margin-bottom: 16px
    span
      commonColor(#797B83, #999999)
  .ivu-layout-sider
    background-color: transparent
    .right_column
      .keyword-input
        margin-top: 16px
      .rigit_title
        font-size: 16px
        top: 84px
      .rigit_content
        top: 134px
  .ivu-layout-content
    background-color: transparent
    margin-left: 16px
    .info
      margin-top: 16px
      padding: 18px 50px
      commonBgColor(#2A2F42, #FFFAF5)
      position: relative
      p
        commonColor(#FFFFFF, #666666)
        font-size: 14px
        line-height: 1
        i
          font-size: 14px
          display: inline-table
          background-size: 100% 100%
          vertical-align: top
          margin-right: 10px
      .info_right
        position: absolute
        right: 50px
        margin: 0
        top: 18px
        .swi
          float: left
          commonColor(#FFFFFF, #666666)
          line-height: 14px
          padding-left: 18px
          border-left: 1px solid
          commonBorderColor(#40444F, #E9E9E9)
          .ivu-switch-small
            height: 14px
            vertical-align: top
            border: 0
            commonBgColor(rgba(255,255,255,0.20), #E8E8E8)
            margin-left: 8px
            &.ivu-switch-checked
              background-color: #FC9C7C
              &:after
                left: 14px
            &:after
              width: 14px
              height: 14px
              top: 0
            &:focus
              box-shadow: none
        .ivu-checkbox-wrapper
          font-size: 0
          float: left
          margin-right: 18px
          display: flex
          & >>> .ivu-checkbox
            font-size: 0
            margin-right: 4px
            .ivu-checkbox-inner
              display: inline-block
              vertical-align: top
              background: transparent
              commonBorderColor(#7A7F94, #D5D5D5)
            &:hover
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), #23294D)
            &-focus
              box-shadow: none
            &.ivu-checkbox-checked
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), #23294D)
                commonBgColor(rgba(250, 122, 80, 1), #23294D)
          span.ivu-checkbox+*
            font-size: 12px
            vertical-align: top
            line-height: 14px
            margin-right: 0
            commonColor(#FFFFFF, #666666)
            &:hover
              color: rgba(250, 122, 80, 1) !important
    .new_tip
      padding: 20px 0
      // background: #1F2330
      commonBgColor(#1F2330, #ffffff)
      position: relative
      p
        width: 300px
        font-size: 12px
        color: #FFFFFF
        text-align: center
        background: #fa7a50
        border-radius: 2px
        line-height: 1
        padding: 10px 0
        margin: 0 auto
        position: relative
        cursor: pointer
      i
        position: absolute
        font-size: 12px
        cursor: pointer
        translateXY50()
        left: 50%
        top: 36px
        margin-left: 136px
        color: #fff
    .news_list
      commonBgColor(#1f2330, #FFFFFF)
      .d-time
        font-size: 14px
        commonBgColor(#2A2F42, #FFFAF5)
        commonColor(#FFFFFF, #666666)
        padding: 12px 50px
      .item
        display: flex
        padding: 16px 0
        margin: 0 50px
      .item + .item
        border-top: 1px solid
        commonBorderColor(#40444F, #F3F3F3)
      .line
        margin: 0 30px
        position: relative
        &:before
          position: absolute
          content: ''
          top: 30px
          bottom: 0
          left: 0
          border-left: 1px dashed
          commonBorderColor(#40444F, #F3F3F3)
        img
          position: absolute
          width: 16px
          height: 16px
          top: 3px
          left: -8px
        img
          &.recommend
            width: 32px
            height: 16px
            left: -16px
      .time
        font-size: 14px
        line-height: 22px
        commonColor(#BCBDC1, #333333)
      .content
        font-size: 14px
        line-height: 22px
        flex: 3
        .tag+span
          margin-left: 6px
        .line_i
          display: inline-block
          vertical-align: top
          width: 1px
          height: 14px
          margin: 4px 6px 0
          commonBgColor(#40444f, #e9e9e9)
        > div:nth-child(1)
          // text-indent: -6px
          a
            display: block
            &.a1
              commonColor(#E9E9EB, #333333)
              font-weight: bold
            &.a2
              margin-top: 4px
              commonColor(#BCBDC1, #666666)
            &:hover
              color: rgba(250, 122, 80, 1) !important
          .bd
            commonColor(#797b83, #999999)
      .div-img
        margin-top: 6px
        font-size: 0
        line-height: 1
        img
          max-width: 160px
          max-height: 80px
          cursor: pointer
        img+img
          margin-left: 20px
      .last-item-row
        display: flex
        justify-content: flex-end
        margin-top: 10px
        min-height: 18px
        line-height: 18px
        .item-row
          flex: 1
          margin-right: 20px
          display: flex
          div+div
            margin-left: 35px
            position: relative
            &:before
              content: ''
              position: absolute
              width: 1px
              height: 12px
              commonBgColor(#40444f, #e9e9e9)
              top: 3px
              // top: 50%
              // transform: translateY(-50%)
              left: -17px
        .t-address
          // display: flex
          // align-items: center
          span
            display: inline
            vertical-align: top
            font-size: 12px
            commonColor(#797b83, #999999)
        .tag-list
          font-size: 12px
          position: relative
          line-height: 18px
          max-width: 620px
          span
            a
              color: rgba(250, 122, 80, 1)
              &:hover
                color: #FC9C7C
          span+span:before
              content: '·'
              margin: 0 9px
              color: #fa7a50
          .iconfont
            font-size: 12px
            margin-right: 10px
            color: rgba(250, 122, 80, 1)
        .spa
          font-size: 12px
          position: relative
          padding-right: 25px
          commonColor(#797b83, #999999)
          i
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            commonColor(#ADAFB4, #cccccc)
            commonBgColor(#343844,#f3f3f3)
            border-radius:2px;
            font-size: 10px;
            display: inline-block;
            cursor: pointer;
            &.s:hover,&.s.active
              color: #fff;
              background:rgba(250, 122, 80, 1);
            &.w:hover,&.w.active
              color: #fff;
              background:#63BF61;
          & >>> .ivu-poptip
            position: absolute
            width: 18px
            height: 18px
            right: 0
            // top: 2px
            .ivu-poptip-rel
              position: absolute
              width: 18px
              height: 18px
              border-radius: 2px
              right: 0
              top: 0
              cursor: pointer
            .ivu-poptip-popper
              transform: translate(13px, 0)
              .ivu-poptip-inner
                border-radius: 0
                .share_cnt
                  padding: 10px 20px 10px 10px
                  .share_img
                    width: 80px
                    height: 80px
                    float: left
                    background: #f0f0f0
                  p
                    line-height: 20px
                    color: #666
                    float: right
                    margin-top: 20px
                    font-size: 14px
      .already
        .time
          commonColor(#8F9198, #999999)
        .content
          > div:nth-child(1)
            a
              commonColor(#8F9198, #999999)
              &:hover
                color: rgba(250, 122, 80, 1)
        .tag-list
          .iconfont
            commonColor(#8F9198, #999999)
          span a
            commonColor(#8F9198, #999999)
            &:hover
              color: rgba(250, 122, 80, 1)
    .more
      commonBgColor(#1f2330, #FFFFFF)
      padding: 25px
      text-align: center
      position: relative
      min-height: 86px
      button
        border: 1px solid rgba(250, 122, 80, 1)
        border-radius: 18px
        width: 108px
        background: none
        color: rgba(250, 122, 80, 1)
        font-size: 14px
        line-height: 1
        padding: 10px 0
        cursor: pointer
        &:hover
          color: #FC9C7C
          border-color: #FC9C7C
      .no_more
        line-height: 36px
        commonColor(rgba(255,255,255,.6), #999999)
.add_atten
  border: 1px dashed rgba(250, 122, 80, 1)
  border-radius: 4px
  display: block
  width: 100%
  color: rgba(250, 122, 80, 1)
  line-height: 32px
  text-align: center
  margin-top: 20px
  margin-bottom: -4px
  font-size: 12px
  &:hover
    color: #FC9C7C
    border-color: #FC9C7C
.advList
  font-size: 0
  padding: 20px 50px
  commonBgColor(#1f2330, #FFFFFF)
  &.latest
    padding-bottom: 0
  img
    width: 100%
    height: 80px
</style>
